import React, { Component } from "react";
import { GenericOption, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';

class Dias extends Component {
    constructor(props) {
        super(props);

        this.changeDays = this.changeDays.bind(this);
    }

    componentDidMount() {
        if (this.props.data.vigencia != undefined) {
            if (this.props.data.vigencia.id)
                this.props.getDays(this.props.data.vigencia.id);
        }
    }

    changeDays(event) {
        this.props.getDays(event.target.value);
    }

    render() {
        let diasNodes;
        let diaElegido;
        if (this.props.data != undefined && this.props.data != "") {
            let days = JSON.parse(JSON.stringify(this.props.data.dias));
            days.unshift({ Id: 0, Descripcion: "Seleccione..." });
            diasNodes = days.map((dia, index) => {
                let selected = false;

                if (this.props.data.vigencia != undefined) {
                    if (dia.Id == this.props.data.vigencia.id)
                        selected = true;
                }

                return <GenericOption
                    id={dia.Id}
                    description={dia.Descripcion}
                    key={"NewDay_" + index}
                    selected={selected} />

            })
        };

        return (
            <div className="col-md-8">
                <div className="row">
                    <div className="col-md-4">
                        <label className="label-primary">Vigencia (dias)</label>
                    </div>
                    <div className="col-md-4">
                        <GenericSelect id="selDays" className="form-control default-select"
                            options={diasNodes} onChange={this.changeDays} />
                    </div>
                    <div className="col-xs-4">
                        {!this.props.data.ERROR_CARD["vigenciaValida"]
                            ? <label className="error">Debe seleccionar al menos un tipo de vigencia.</label>
                            : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default Dias